import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import { signal } from '@angular/core';

export abstract class GridCellRenderer<TRow, TValue> implements ICellRendererAngularComp {

    value = signal<TValue | null>(null);
    row = signal<TRow | null>(null);

    agInit(params: ICellRendererParams<TRow, TValue, any>): void {
      this.value.set(params.value ?? null);
      this.row.set(params.data ?? null);
    }

    refresh(params: ICellRendererParams<TRow, TValue, any>): boolean {
      this.value.set(params.value ?? null);
      this.row.set(params.data ?? null);
      return true;
    }
}

